
<template>
  <div>
    <Card v-if="!nextLoading">
      <div class="number_pointNew" v-show="form.applicationNo">流水号：<span>{{form.applicationNo}}</span></div>
      <table class="table_flower" style="margin-bottom:10px;">
        <tr>
          <th width="20%">申请人姓名</th>
          <td>{{form.applicantName}}</td>
          <th width="20%">申请人身份证号</th>
          <td>{{form.applicantIDCardNo}}</td>
        </tr>
        <!-- <tr>
          <th>补交材料要求</th>
          <td colspan="3">
            {{ form.xbsL_Content}}
          </td>
        </tr> -->
        <tr>
          <th>补交材料类型</th>
          <td colspan="3">
            <template v-if="form.applicationType==$store.state.applicationType['居住证积分新办']">
              <span v-for="(supplementaryMaterial,index) in form.supplementaryMaterialTypeDetail.supplementaryMaterialTypeList" :key="index">
                {{supplementaryMaterial.name}}<span v-if="index<(form.supplementaryMaterialTypeDetail.supplementaryMaterialTypeList.length-1)">、</span>
              </span>
            </template>
            <span v-else>{{form.补交材料类型Text}}</span>
          </td>
        </tr>
      </table>
      <Collapse v-model="value">
        <template v-if="form.isShow_申请人信息">
          <Panel name="2">
            申请人信息
            <template #content>
              <basic-detail :form="form" @handleView="handleView" :hasLaborDispatchPermit="hasLaborDispatchPermit" @handlePreview="handlePreview"></basic-detail>
            </template>
          </Panel>
        </template>
        <template v-if="form.isShow_配偶信息">
          <Panel name="3">
            配偶信息
            <template #content>
              <spouse-detail :form="form" @handleView="handleView" @handlePreview="handlePreview"></spouse-detail>
            </template>
          </Panel>
        </template>
        <template v-if="form.isShow_子女信息">
          <Panel name="4">
            同住子女信息
            <template #content>
              <child-detail :form="form" @handleView="handleView" @handlePreview="handlePreview"></child-detail>
            </template>
          </Panel>
        </template>
        <template v-if="form.isShow_最高学历信息">
          <Panel name="5">
            学历信息
            <template #content>
              <education-detail :form="form" @handleView="handleView" @handlePreview="handlePreview"></education-detail>
            </template>
          </Panel>
        </template>
        <template v-if="form.isShow_专科学历信息">
          <Panel name="6">
            专科学历信息
            <template #content>
              <junior-college @handlePreview="handlePreview" :form="form.juniorCollegeEducation" @handleView="handleView" />
            </template>
          </Panel>
        </template>
        <template v-if="form.isShow_职称材料信息||form.isShow_技能等级材料信息||form.isShow_表彰奖励材料信息||form.isShow_投资纳税材料信息 ||form.isShow_孵化器材料信息">
          <Panel name="7">
            加分材料信息
            <template #content>
              <bonus-material :form="form" @handleView="handleView" @handlePreview="handlePreview"></bonus-material>
            </template>
          </Panel>
        </template>
        <template v-if="form.isShow_个人变更信息">
          <Panel name="8">
            个人信息变更
            <template #content>
              <change-info-detail :form="form" @handleView="handleView" @handlePreview="handlePreview"></change-info-detail>
            </template>
          </Panel>
        </template>
        <template v-if="form.isShow_其他信息">
          <Panel name="9">
            其他材料
            <template #content>
              <other :form="form" @handleView="handleView" @handlePreview="handlePreview"></other>
            </template>
          </Panel>
        </template>
      </Collapse>
      <!-- <unit-detail :form="form" :enterpriseAgentList="enterpriseAgentList"></unit-detail> -->
      <!-- <basic-detail :form="form" @handleView="handleView"></basic-detail> -->
      <!-- <spouse-detail :form="form" @handleView="handleView"></spouse-detail> -->
      <!-- <child-detail :form="form" @handleView="handleView"></child-detail> -->

    </Card>
    <Spin size="large" fix v-if="nextLoading"></Spin>

  </div>
</template>
<script>
import '../styles/points.less'
import UnitDetail from './modules/unitDetail/index'
import BasicDetail from './modules/basicDetail/index'
import SpouseDetail from './modules/spouseDetail/index.vue'
import ChildDetail from './modules/childDetail/index.vue'
import EducationDetail from './modules/educationDetail/index.vue'
import JuniorCollege from './modules/educationDetail/juniorCollege'
import BonusMaterial from './modules/bonusMaterial/index.vue'
import other from './modules/other/index'
import ChangeInfoDetail from './modules/changeInfoDetail/index.vue'

export default {
  components: {
    UnitDetail,
    BasicDetail,
    SpouseDetail,
    ChildDetail,
    EducationDetail,
    JuniorCollege,
    BonusMaterial,
    other,
    ChangeInfoDetail,
  },
  data() {
    return {
      value: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
      form: {}, //当前数据
      currentGuid: '', //当前数据guid
      appInfoDataType: this.$store.state.appInfoDataType, //查询数据状态
      nextLoading: false, //页面加载效果
      enterpriseAgentList: [], //经办人列表
      hasLaborDispatchPermit: false,
    }
  },
  mounted() {
    this.currentGuid = this.$route.query.guid
    this.getFullInfo(this.currentGuid, this.appInfoDataType['全部'])
  },
  methods: {
    //获取全部信息
    async getFullInfo(guid, loadAppInfoTypes) {
      this.nextLoading = true
      try {
        const { data } = await this.$Ajax.get(`/api/services/app/JZZJFApi/GetXBAppFullInfo`, {
          params: { guid, loadAppInfoTypes },
        })
        //数据处理
        if (!data.result.personalInfoChange) {
          data.result.personalInfoChang = {}
        }
        //赋值
        this.form = {
          // ...data.result.spouse,
          childrenList: data.result.childrenList,
          ...data.result.mainInfo,
          ...data.result.spouse,
          ...data.result.education,
          ...data.result.personalInfoChange,
          plusInvestmentTaxationDrivingLocalEmploymentList:
            data.result.plusInvestmentTaxationDrivingLocalEmploymentList,
          plusIncubatorMaterialList: data.result.plusIncubatorMaterialList,
          plusRecognitionAwardList: data.result.plusRecognitionAwardList,
          plusSkillLevelList: data.result.plusSkillLevelList,
          plusTitleList: data.result.plusTitleList,
          spouseList: data.result.spouseList,
          juniorCollegeEducation: data.result.juniorCollegeEducation,
          prequalificationFeedBackList: data.result.prequalificationFeedBackList,
          supplementaryMaterialTypeDetail: data.result.supplementaryMaterialTypeDetail,
          isShow_专科学历信息: data.result.isShow_专科学历信息,
          isShow_个人变更信息: data.result.isShow_个人变更信息,
          isShow_其他信息: data.result.isShow_其他信息,
          isShow_子女信息: data.result.isShow_子女信息,
          isShow_孵化器材料信息: data.result.isShow_孵化器材料信息,
          isShow_技能等级材料信息: data.result.isShow_技能等级材料信息,
          isShow_投资纳税材料信息: data.result.isShow_投资纳税材料信息,
          isShow_最高学历信息: data.result.isShow_最高学历信息,
          isShow_申请人信息: data.result.isShow_申请人信息,
          isShow_职称材料信息: data.result.isShow_职称材料信息,
          isShow_表彰奖励材料信息: data.result.isShow_表彰奖励材料信息,
          isShow_配偶信息: data.result.isShow_配偶信息,
        }

        this.currentGuid = this.form.guid
        /* 
        时间处理
         */
        if (this.form.applicantResidencePermitExpiryDate) {
          this.form.applicantResidencePermitExpiryDate = new Date(
            this.form.applicantResidencePermitExpiryDate
          )
        }
        if (this.form.enrolDate) {
          this.form.enrolDate = new Date(this.form.enrolDate)
        }
        if (this.form.graduationDate) {
          this.form.graduationDate = new Date(this.form.graduationDate)
        }
        if (this.form.juniorCollegeEducation.enrolDate) {
          this.form.juniorCollegeEducation.enrolDate = new Date(
            this.form.juniorCollegeEducation.enrolDate
          )
        }
        if (this.form.juniorCollegeEducation.graduationDate) {
          this.form.juniorCollegeEducation.graduationDate = new Date(
            this.form.juniorCollegeEducation.graduationDate
          )
        }

        this.enterpriseAgentList = data.result.basicData.enterpriseAgentList
        this.isEnterprise = data.result.basicData.isEnterprise
        this.hasLaborDispatchPermit = data.result.basicData.enterpriseHasLaborDispatchPermit
        this.$store.state.isPassFilesManagementAptitude =
          data.result.basicData.isPassFilesManagementAptitude

        this.enterpriseAgentList = data.result.basicData.enterpriseAgentList

        this.$store.state.isDisableEnterpriseAgentInput =
          data.result.basicData.isDisableEnterpriseAgentInput
        this.$store.state.isPerson = data.result.basicData.isPerson
        this.isEnterprise = data.result.basicData.isEnterprise
        this.$store.state.enterpriseHasLaborDispatchPermit =
          data.result.basicData.enterpriseHasLaborDispatchPermit
        this.$store.state.enterpriseIsShanghaiBranch =
          data.result.basicData.enterpriseIsShanghaiBranch
        this.$store.commit('setMateriaBasicData', data.result.basicData.enumData)
      } catch (error) {}
      this.nextLoading = false
    },
    //查看图片文件
    handleView(guid) {
      let _this = this

      const $viewer = this.$viewerApi({
        options: {
          toolbar: true,
          initialViewIndex: 0,
        },
        images: [_this.$baseURL + '/file/preview/' + guid],
      })
    },
    //查看文件
    handlePreview(file) {
      if (typeof file !== 'object') {
        //单个图片
        // window.open(this.$baseURL + '/file/preview/' + file)
        const $viewer = this.$viewerApi({
          options: {
            toolbar: true,
            initialViewIndex: 0,
          },
          images: [this.$baseURL + '/file/preview/' + file],
        })
        return
      }
      let _this = this
      if (file.url) {
        let fileExtension
        if (file.name.indexOf('.') >= 0) {
          fileExtension = file.name.split('.').pop().toLowerCase()
        } else {
          fileExtension = ''
        }

        if (fileExtension === 'jpg' || fileExtension === 'jpeg' || fileExtension === 'png') {
          const $viewer = this.$viewerApi({
            options: {
              toolbar: true,
              initialViewIndex: 0,
            },
            images: [_this.$baseURL + file.url],
          })
          return
        }
        window.open(this.$baseURL + file.url)
        return
      }
      if (file.status == 'finished') {
        let fileExtension
        if (file.url.indexOf('.') >= 0) {
          fileExtension = file.response.result.fileName.split('.').pop().toLowerCase()
        } else {
          fileExtension = ''
        }
        if (fileExtension === 'jpg' || fileExtension === 'jpeg' || fileExtension === 'png') {
          const $viewer = this.$viewerApi({
            options: {
              toolbar: true,
              initialViewIndex: 0,
            },
            images: [_this.$baseURL + file.response.result.imageUrl],
          })
          return
        }
        window.open(this.$baseURL + file.response.result.imageUrl)
      }
    },
  },
}
</script>
<style scoped>
.logrem {
  white-space: pre-line;
}
</style>